/*
 *
 *  * (C) Copyright 2006-2020 hSenid Mobile Solutions (Pvt) Limited.
 *  *
 *  * All Rights Reserved.
 *  *
 *  * These materials are unpublished, proprietary, confidential source code of
 *  * hSenid Mobile Solutions (Pvt) Limited and constitute a TRADE SECRET
 *  * of hSenid Mobile Solutions (Pvt) Limited.
 *  *
 *  * hSenid Mobile Solutions (Pvt) Limited retains all title to and intellectual
 *  * property rights in these materials.
 *  *
 *
 */

import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { MainPageEvent, useMainPageDataSelector } from ".";
import HmsInput, { ValidationProps } from "../Common/element/HmsInput";
import configData from "../../config.json";
import Modal from "react-bootstrap/Modal";

interface ModalProps {
  setMSISDN(s: string): void;
  MSISDN: string;
}

function LoginModal({ setMSISDN, MSISDN }: ModalProps) {
  const dispatch = useDispatch();
  const [validity, setValidity] = useState<boolean>(false);
  const mainPageData = useMainPageDataSelector();
  const reg = /^880\d{10}$/;

  const validation: ValidationProps = {
    regExVal: reg,
    regexErrorMsg: configData.VALIDATION_MESSAGES.MSISDN_REGEX,
  };

  const submitMsisdn = () => {
    if (validity) {
      dispatch({
        type: MainPageEvent.OTP_REQUEST,
        msisdn: MSISDN,
      });
      setMSISDN("");
    }
  };

  return (
    <Modal
      show={mainPageData.showSignInModal}
      onHide={() => {
        dispatch({
          type: MainPageEvent.HIDE_SIGNIN_MODAL,
        });
        setMSISDN("");
      }}
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header closeButton>
        <Modal.Title>OTP Login</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>Please enter your mobile number</p>
        <HmsInput
          inputType="text"
          className="form-control bg-back border-0"
          placeHolder={configData.PLACEHOLDERS.LOGIN}
          value={MSISDN}
          validProps={validation}
          handleChange={setMSISDN}
          setValidity={setValidity}
        />
      </Modal.Body>
      <Modal.Footer>
        <button
          className="btn btn-light"
          data-dismiss="modal"
          onClick={() => {
            dispatch({
              type: MainPageEvent.HIDE_SIGNIN_MODAL,
            });
            setMSISDN("");
          }}
        >
          Close
        </button>
        <button
          disabled={mainPageData.signingIn}
          className="btn btn-primary"
          type="button"
          data-toggle="modal"
          data-target="#verify-otp-modal"
          onClick={() => {
            submitMsisdn();
          }}
        >
          <i
            className={
              mainPageData.signingIn ? "fas fa-spin fa-circle-notch" : ""
            }
          ></i>
          {mainPageData.signingIn ? "Requesting..." : "Request"}
        </button>
      </Modal.Footer>
    </Modal>
  );
}

export default LoginModal;
